/* eslint-disable import/prefer-default-export */
import { ConversationStreamEvent } from '@centecomm/portal-service';
import { format } from 'date-fns';

import { ChunkedEvents } from '../Features/Conversations/Types';

export const chunkConversationEvents = (
    conversationEvents: ConversationStreamEvent[],
    dateFnsLocale?: Locale,
): ChunkedEvents => {
    const chunked: ChunkedEvents = conversationEvents.reduce((chunks: ChunkedEvents, current: ConversationStreamEvent) => {
        const eventDate: string = format(new Date(current.event.metadata.eventDate), 'PPPP', { locale: dateFnsLocale });

        return {
            ...chunks,
            [eventDate]: [...(chunks[eventDate] || []), current],
        };
    }, {});

    return chunked;
};
